import React from 'react';
import { NavigateNext } from '@mui/icons-material';
import { Breadcrumbs, Button, Typography } from '@mui/material';
import { guaranteesLayoutStyles } from '../../styles.ts';
import type { IBreadcrumbItemProps, IBreadcrumbsBarProps } from './types.ts';

const BreadcrumbItem: React.FC<IBreadcrumbItemProps> = ({ breadcrumb, isLast, onNavigate }) => {
  const breadcrumbPath = breadcrumb.path;
  const isInteractive = !!breadcrumbPath && !isLast;

  return isInteractive ? (
    <Button
      disableRipple
      onClick={() => onNavigate(breadcrumbPath)}
      sx={guaranteesLayoutStyles.breadcrumbLink}
    >
      {breadcrumb.label}
    </Button>
  ) : (
    <Typography
      component="span"
      sx={isLast ? guaranteesLayoutStyles.currentBreadcrumb : guaranteesLayoutStyles.breadcrumbText}
    >
      {breadcrumb.label}
    </Typography>
  );
};

const BreadcrumbsBar: React.FC<IBreadcrumbsBarProps> = ({ breadcrumbs, onNavigate }) => {
  return (
    <Breadcrumbs
      separator={<NavigateNext fontSize="small" sx={guaranteesLayoutStyles.breadcrumbSeparator} />}
      sx={guaranteesLayoutStyles.breadcrumbs}
    >
      {breadcrumbs.map((breadcrumb, index) => (
        <BreadcrumbItem
          key={`${breadcrumb.label}-${breadcrumb.path ?? index}`}
          breadcrumb={breadcrumb}
          isLast={index === breadcrumbs.length - 1}
          onNavigate={onNavigate}
        />
      ))}
    </Breadcrumbs>
  );
};

export default BreadcrumbsBar;
